/**
 * Reports API service for Pro features
 */

import api from './api';

const reportService = {
  // Generate insurance report
  async generateInsuranceReport(options = {}) {
    try {
      const response = await api.post('/reports/insurance', {
        box_ids: options.boxIds,
        min_value: options.minValue
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to generate insurance report');
    }
  },

  // Generate moving report
  async generateMovingReport(options = {}) {
    try {
      const response = await api.post('/reports/moving', {
        box_ids: options.boxIds,
        location_filter: options.locationFilter
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to generate moving report');
    }
  },

  // Get all user reports
  async getUserReports(reportType = null) {
    try {
      const params = reportType ? { type: reportType } : {};
      const response = await api.get('/reports', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to get reports');
    }
  },

  // Export report as CSV
  async exportReport(reportId) {
    try {
      const response = await api.post(`/reports/${reportId}/export`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to export report');
    }
  },

  // Delete a report
  async deleteReport(reportId) {
    try {
      const response = await api.delete(`/reports/${reportId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to delete report');
    }
  }
};

export default reportService;
